import {Face3, Face4, Vector3, Box3} from 'three'
/**
 * Dumping ground for abanonded threejs functionality that
 * our code still requires.
 *
 * Eventually, we will rewrite the 3d object loaders to utilize the
 * new methods exposed in threejs RC >= .125
 */
const geometryHelpers = {
  /**
   * Drop-in replacement for method removed from newer versions of js. Allows
   * us to continue calling this method without having to excplicitly vendor
   * the library.
   *
   * @param Geometry geometry An instance of a threejs geometry object
   */
  computeFaceCentroids(geometry) {
    let f, fl, face

    for (f = 0, fl = geometry.faces.length; f < fl; f++) {
      face = geometry.faces[f]
      face.centroid = new Vector3(0, 0, 0)

      if (face instanceof Face3) {
        face.centroid.add(geometry.vertices[face.a])
        face.centroid.add(geometry.vertices[face.b])
        face.centroid.add(geometry.vertices[face.c])
        face.centroid.divideScalar(3)
      } else if (face instanceof Face4) {
        face.centroid.add(geometry.vertices[face.a])
        face.centroid.add(geometry.vertices[face.b])
        face.centroid.add(geometry.vertices[face.c])
        face.centroid.add(geometry.vertices[face.d])
        face.centroid.divideScalar(4)
      }
    }
  },
  computeBoundingBox(geo) {
    if (geo.boundingBox === null) {
      geo.boundingBox = new Box3()
    }

    const {boundingBox} = geo
    const points = geo.vertices

    if (points.length === 0) {
      boundingBox.makeEmpty()
      return
    }

    let point = points[0]

    boundingBox.min.copy(point)
    boundingBox.max.copy(point)

    for (let i = 1, il = points.length; i < il; i++) {
      point = points[i]

      if (point.x < boundingBox.min.x) {
        boundingBox.min.x = point.x
      } else if (point.x > boundingBox.max.x) {
        boundingBox.max.x = point.x
      }

      if (point.y < boundingBox.min.y) {
        boundingBox.min.y = point.y
      } else if (point.y > boundingBox.max.y) {
        boundingBox.max.y = point.y
      }

      if (point.z < boundingBox.min.z) {
        boundingBox.min.z = point.z
      } else if (point.z > boundingBox.max.z) {
        boundingBox.max.z = point.z
      }
    }
  }
}

export default geometryHelpers
